module.exports = __webpack_public_path__ + "img/ico200.abf58944.svg";